import React, { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import HtmlParser from 'react-html-parser';
import { coinRateModelGet, } from '../../models/coinRates/coinRate.js';
import {
    dataTableLanguaje, buttonProcessGet, globalSettings, processEvaluateGet, responseGet, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet,
    numberSet, separatorsNumbersSet, styles, validateDecimals, languageObjGet, isUndNullEmp, awaitDelay, isNumber, LoadingSection
} from '../../helpers/settings';
import axios from 'axios';
import Swal from 'sweetalert2';
import { coinModelGet } from '../../models/coins/coin.js';
import { GlobalFormats } from '../../classes/main/globalFormats.js';

const currentMethod = 'CoinRates';
const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;
const { app, collections: dbColle, colors, html, icons, images, labels, messages, react, } = globalSettings;
const { tempusDominus, html: reactHtml, sweetAlert2 } = react;
const { properties: dbProps, } = dbColle;
const { backend, } = app;

export default function CoinRates({
    $ = {},
    auth = {},
    coin = coinModelGet(),
    rates = [],
    setRates = () => { },
    ratesDt = {},
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),

}) {
    //#region variables
    let result = {};
    let dataObj = {};
    let headerObj = {};
    const [rateValues, setRateValues] = useState({
        id: '',
        description: '',
        rowIndex: 0,
        type: 0,
    });
    const [isEditDelete] = useState(coin?.process?.edit || false);
    const [showLoading, setShowLoading] = useState({ rates: false, });
    //#endregion variables

    //#region coin rate
    const rateDateId = 'rateDate';
    const [coinRate, setCoinRate] = useState(coinRateModelGet({}));
    const dtCoinRatesId = 'dtCoinRatesId';
    const [rateRateError, setRateRateError] = useState('');
    const [rateDateError, setRateDateError] = useState('');
    //#endregion coin rate

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnCoinRatesModalSave',
                className: 'btn btn-outline-warning btn-sm mx-1',
            },
            new: {
                id: 'btnCoinRatesModalNew',
                className: 'btn btn-outline-success btn-sm',
            },
            back: {
                id: 'btnCoinRatesModalBack',
                className: 'btn btn-outline-success btn-sm',
            },
            close: {
                id: 'btnCoinRatesModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkCoinRatesModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCoinRatesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCoinRatesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCoinRatesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCoinRatesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCoinRatesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCoinRatesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCoinRatesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCoinRatesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoCoinRatesModalSave',
                className: icons?.save,
            },
            new: {
                id: 'icoCoinRatesModalNew',
                className: icons?.fileAltFar,
            },
            back: {
                id: 'icoCoinRatesModalBack',
                className: icons?.arrowAltCircleLeft,
            },
            close: {
                id: 'icoCoinRatesModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            rate: {
                id: 'inputCoinRatesModalDescription',
                className: 'form-control text-right',
            },
            date: {
                id: 'inputCoinRatesModalDate',
                className: 'form-control datetimepicker-input',
            },
        },
        selects: {
            // coins: {
            //     id: 'selCoinRatesModalCoins',
            //     className: 'form-select',
            // },
        },
        spinners: {
            save: {
                id: 'spCoinRatesModalSave',
                className: '',
            },
            new: {
                id: 'spCoinRatesModalNew',
                className: '',
            },
            back: {
                id: 'spCoinRatesModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region coin rate (methods)
    const coinRateAddEditDeleteGetAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'coinRateAddEditDeleteGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let coinRateLocal = coinRateModelGet({});
            //#endregion variables

            if (processType === 0) {
                controlsStatusSet({ processType: 3, subMethod: currentMethod, });
            } else if (processType !== -1) {
                setShowLoading({ rates: true, });
            }

            //#region initialize
            coinRateLocal = coinRateModelGet({
                buildingId: coin?.buildingId,
                coinId: coin?.id,
                userId: auth?.user?.uid,
            });
            //#endregion initialize

            //#region process
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            switch (processType) {
                case -1:
                    //#region show message
                    let msgTextObj = {
                        one: `${labels?.rate?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    const swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        html: `${msgTextObj?.one}${msgTextObj?.two}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true, //!Swal.isLoading(), //true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        preConfirm: async () => {
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal?.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}...`,
                                    html: `${msgTextObj?.one}`,
                                    showConfirmButton: false,
                                });

                                //#region delete countr
                                headerObj = {
                                    headers: {
                                        languageId: languageObj?.id,
                                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                    },
                                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoinRates}/${id}`
                                };

                                result = await axios.delete(
                                    headerObj?.url,
                                    headerObj,
                                );

                                response = result?.data || {};

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion delete country

                                //#region delete country (dataTable)
                                $(`#${dtCoinRatesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                                //#endregion delete country (dataTable)

                                //#region data set
                                setCoinRate(coinRateLocal);
                                setRateValues({
                                    id: '',
                                    description: '',
                                    rowIndex: 0,
                                    type: 0,
                                });
                                //#endregion data set

                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: 0,
                                    msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            } catch (ex) {
                                //#region Error
                                response.isSuccess = false;
                                response.msgType = -1;
                                response.msgText = `Method: ${currentMethod}<br/>`;
                                response.msgText += `Error: ${ex?.message}`;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                //#endregion Error
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                    };

                    await Swal.fire(swalProperties);
                    //#endregion show message   
                    return;
                    //break;
                case 0:
                    setRateRateError('');
                    setRateDateError('');

                    response = dateInControlSet({
                        date: new Date(),
                        rateDate: undefined,
                        processType: 1,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processType === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        } else if (processType !== -1) {
                            setShowLoading({ rates: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                    break;
                case 1:
                    //#region data get (rate)
                    headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlCoinRates}/${id}`;
                    headerObj.languageId = languageObj?.id;

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processType === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        } else if (processType !== -1) {
                            setShowLoading({ rates: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    coinRateLocal = response?.result?.rate || {};

                    response = dateInControlSet({
                        date: null,
                        rateDate: coinRateLocal?.date,
                        processType: 1,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processType === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        } else if (processType !== -1) {
                            setShowLoading({ rates: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    //#endregion data get (rate)
                    break;
                default: break;
            }

            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType !== -1) {
                setShowLoading({ rates: false, });
            }

            if (processType !== -1) {
                setCoinRate(coinRateLocal);
                setRateValues({ id, description, rowIndex, type: processType });
            } else {
                // setCoinRate(coinRateLocal)
                // setRateValues({ id: '', description: '', rowIndex: 0, type: 0 });
                // await sendMessageCloseCurrentWindowAsync(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], false, response.urlGoTo, auth, false);
            }
            //#endregion process
        } catch (ex) {
            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType !== -1) {
                setShowLoading({ rates: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const coinRateAddEditPostAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'coinRateAddEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRw = [];
            let coinRateLocal = coinRateModelGet({});
            //#endregion variables

            //#region data set / validate form data
            if (rateValues.type !== -1) {
                response = dataSet({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                response = await formDataValidateAsync({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
            }
            //#endregion data set / validate form data

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region process
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            switch (rateValues.type) {
                case 0:
                    //#region add data (rate)
                    dataObj = {
                        coinRate: coinRate,
                        languageCode: languageObj?.code,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoinRates}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    coinRateLocal = response?.result?.rate || {};
                    //#endregion add data (rate)
                    break;
                case 1:
                    //#region add data (rate)
                    dataObj = {
                        coinRate: coinRate,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoinRates}/${coinRate?.id}`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    coinRateLocal = response?.result?.rate || {};
                    //#endregion add data (rate)
                    break;
                default: break;
            }
            //#endregion process

            //#region set dataTable
            if (!rateValues.type !== -1) {
                //#region variables
                dataObj = {
                    dateTimeOrder: dateTimeFormatGlobalSet({
                        date: coinRateLocal?.date,
                        type: tempusDominus?.format?.date?.ymdTwo,
                        format: 24,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    amount: separatorsNumbersSet({
                        number: coinRateLocal?.rate,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    dateTime: dateTimeFormatGlobalSet({
                        date: coinRateLocal?.date,
                        type: languageObj?.format?.date?.f1,
                        format: languageObj?.format?.time?.type,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    description: '',
                };
                dataObj.description = `${labels?.date?.[languageObj?.id]}: <b>${dataObj?.dateTime}</b><br/>`;
                dataObj.description += `${labels?.rate?.[languageObj?.id]}: <b>${dataObj?.amount}</b>`;
                //#endregion variables

                //#region methods
                dtRw = [
                    dataObj?.dateTimeOrder,
                    dataObj?.amount,
                    dataObj?.dateTime,
                    buttonProcessGet({
                        id: coinRateLocal.id,
                        description: dataObj?.description,
                        showDetails: false,
                        labelDetails: '',
                        enabledDetails: false,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: processEvaluateGet({
                            object: coinRateLocal,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: processEvaluateGet({
                            object: coinRateLocal,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result,
                ];
                //#endregion variables
            }

            switch (rateValues.type) {
                case 0:
                    $(`#${dtCoinRatesId}`)?.DataTable()?.row?.add(dtRw)?.draw(true);
                    break;
                case 1:
                    $(`#${dtCoinRatesId}`)?.DataTable()?.row(rateValues.rowIndex).data(dtRw)?.draw(true);
                    break;
                default:
                    break;
            }
            //#endregion set dataTable

            //#region set rate value
            response = await coinRateAddEditDeleteGetAsync({
                e: undefined,
                id: '',
                description: '',
                rowIndex: 0,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return response;
            }
            //#endregion set rate value

            setRateValues({ id: '', description: '', rowIndex: 0, type: 0 });

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion coin rates (methods)

    //#region methods (others)
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            $(`#${dtCoinRatesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.date?.[languageObj?.id], visible: false, width: '0%', },
                    { title: labels?.rate?.[languageObj?.id], className: 'text-right', visible: true, width: '35%', },
                    { title: labels?.date?.[languageObj?.id], visible: true, width: '60%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                autoWidth: false,
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //lengthChange: true,
                lengthChange: false,
                order: [[0, 'desc']],
                responsive: true,
                searching: true,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtCoinRatesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtCoinRatesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            coinRateAddEditDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            coinRateAddEditDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dateInControlSet = ({
        date = new Date(),
        rateDate = undefined,
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            //#region variables
            let dateTimeObj = {
                dateTime: '',
                dateFormat: languageObj?.format?.date?.f1,
                dateTwoFormat: languageObj?.format?.date?.f11,
                timeFormat: languageObj?.format?.time?.type,
                timeTwoFormat: languageObj?.format?.time?.picker?.hhmm,
            }
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: rateDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.dateTime = dateTimeFormatGlobalSet({
                    date: rateDate,
                    type: dateTimeObj?.dateFormat,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.dateTime = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.dateFormat,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (processType === 0) {
                $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                    icons: tempusDominus?.icons,
                    buttons: tempusDominus?.buttons,
                    tooltips: tempusDominus?.tooltips,
                    locale: languageObj?.id,
                });

                $(`#${rateDateId}`)?.datetimepicker({
                    date: moment(dateTimeObj?.dateTime, `${dateTimeObj?.dateTwoFormat} ${dateTimeObj?.timeTwoFormat}`),
                    default: false,
                    timepicker: false,
                    format: `${dateTimeObj?.dateTwoFormat} ${dateTimeObj?.timeTwoFormat}`,
                });
            } else if (processType === 1) {
                $(`#${rateDateId}`)?.datetimepicker(
                    'date',
                    moment(dateTimeObj?.dateTime, `${dateTimeObj?.dateTwoFormat} ${dateTimeObj?.timeTwoFormat}`)
                );
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region set dataTable
            response = dataTablesSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion set dataTable

            //#region queryCode set
            response = queryCodeSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#endregion queryCode set

            $(`#${dtCoinRatesId}`)?.DataTable()?.rows?.add(ratesDt)?.draw(true);

            //#region dateTime in control sets
            response = dateInControlSet({
                date: new Date(),
                rateDate: {},
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dateTime in control sets

            //#region set rate value
            response = await coinRateAddEditDeleteGetAsync({
                e: undefined,
                id: '',
                description: '',
                rowIndex: 0,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await defaultValueSetAsync(true);
            }
            //#endregion set rate value
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataSet = async ({
        property = '',
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'formDataSet';
        let response = responseGet();
        try {
            setCoinRate({
                ...coinRate,
                [property]: value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const dataSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataSet';
        let response = responseGet();
        try {
            //#region variables
            const coinRateDateTime = $(`#${rateDateId}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region methods
            coinRate.date = !isUndNullEmp({ data: coinRateDateTime, subMethod: currentMethod, })?.result ?
                new Date(coinRateDateTime)?.toISOString() :
                coinRate?.date;
            coinRate.rate = numberSet({
                number: coinRate?.rate,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const formDataValidateAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const coinRateDateTime = $(`#${controls?.inputs?.date?.id}`)?.val();
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: coinRateDateTime, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: coinRate?.date, subMethod: currentMethod, })?.result) {
                setRateDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: coinRate?.rate, subMethod: currentMethod, })?.result) {
                setRateRateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (coinRate?.rate <= neutralValue ||
                !isNumber({ number: coinRate?.rate, languageId: languageObj?.id, subMethod: currentMethod })?.result) {
                setRateRateError(`${labels?.amount?.[languageObj?.id]}. ${messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.new?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.new?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.rate?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.date?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.selects?.coins?.id}`)?.attr({ disabled: processType !== 0, });
            //$(`#${controls?.inputs?.cashInitial?.id}`)?.attr({ disabled: processType !== 0, });
            //$(`#${controls?.inputs?.balanceInitial?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.new?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }
    //#endregion methods (others)

    useEffect(() => {
        dataSetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.cashRegister?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={images?.graphBarLogo}></img> - {labels?.rates?.[languageObj?.id]}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.coin?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{coin?.description || ''}</b>
                    </div>
                    <hr />
                </div>
                {isEditDelete ?
                    <form onSubmit={(e) => coinRateAddEditPostAsync({ e: e, id: '', description: '', rowIndex: 0, processType: rateValues?.type, subMethod: 'form - onsubmit' })}>
                        <div className='row text-muted'>
                            <div className='form-group'>
                                <label>{rateValues.type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}</label>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.rate?.id}
                                            className={controls?.inputs?.rate?.className}
                                            // autoFocus
                                            placeholder={labels?.name?.[languageObj?.id]}
                                            tabIndex={0}
                                            tooltip='tooltip'
                                            title={labels?.rate?.[languageObj?.id]}
                                            onChange={(e) => formDataSet({
                                                property: dbProps?.rate,
                                                value: validateDecimals({
                                                    e: e,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'input - rate',
                                                }),
                                                subMethod: 'input - rate',
                                            })}
                                            onFocus={() => setRateRateError('')}
                                            value={coinRate?.rate || '0.00'}
                                        />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={icons?.chartLine} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(rateRateError)}</div>
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <div id={rateDateId}
                                            className='input-group date'
                                            data-target-input='nearest'>
                                            <input id={controls?.inputs?.date?.id}
                                                className={controls?.inputs?.date?.className}
                                                data-target={`#${rateDateId}`}
                                                data-toggle='datetimepicker'
                                                onFocus={() => setRateDateError('')}
                                                placeholder={labels?.date?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.date?.[languageObj?.id]}
                                                type='text' />
                                            <div className='input-group-append'
                                                data-target={`#${rateDateId}`}
                                                data-toggle='datetimepicker'>
                                                <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(rateDateError)}</div>
                                </div>
                            </div>
                        </div>

                        <div className='form-group text-right'>
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                disabled={!isEditDelete}
                                title={labels?.save?.[languageObj?.id]}
                                type='submit'>
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                            </button>
                            <button id={controls?.buttons?.new?.id}
                                className={controls?.buttons?.new?.className}
                                disabled={!isEditDelete}
                                onClick={(e) => coinRateAddEditDeleteGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btn - new', })}
                                title={labels?.new?.[languageObj?.id]}
                                type='button'>
                                <i id={controls?.icons?.new?.id} className={controls?.icons?.new?.className} /> <span id={controls?.spinners?.new?.id} className='' aria-hidden='true'></span>
                            </button>
                        </div>
                        <hr />
                    </form>
                    :
                    <></>
                }

                <div className='row'>
                    <div className='col-md-12'>
                        <LoadingSection alt='loadingSection'
                            className={reactHtml?.overlay?.darkTextWhite}
                            showText={true}
                            text={messages?.processing?.[languageObj?.id]}
                            height={25}
                            hidden={!showLoading?.rates}
                            width={25}
                            languageId={languageObj?.id}
                            subMethod={currentMethod} />
                        <div className={html?.dataTables?.formats?.tableResponsiveSm}>
                            <table id={dtCoinRatesId} className={html?.dataTables?.formats?.smStripedBordered} />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button id={controls?.buttons?.back?.id}
                    className={controls?.buttons?.back?.className}
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btn - back', })}
                    title={labels?.close?.[languageObj?.id]}
                    type='buttons'>
                    <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                </button>
            </Modal.Footer>
        </Modal>
    )
}